// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "f09654878951fc2e5baf0c52946c1d61",
  base: "https://api.openweathermap.org/data/2.5/",
};
